{
  "act1": [
    { "id": "intro.courier", "text": "Take a Courier job at the Clinic Corner kiosk (E, Jobs tab) and deliver the package", "target": { "poi": "kiosk2" }, "point": "KIOSK" },
    { "id": "intro.theft", "text": "Take a Vehicle Theft job at a kiosk and deliver the car to the chop shop", "target": { "poi": "kiosk2" }, "point": "KIOSK" },
    { "id": "intro.gear", "text": "Spend your pay at Hachi's: buy ammo or a gun", "target": { "poi": "weapons" }, "point": "HACHI'S" },
    { "id": "garage.job", "text": "Take the fixer's special job at the Clinic Corner kiosk (Jobs tab)", "target": { "poi": "kiosk2" }, "point": "KIOSK" },
    { "id": "garage.steal", "text": "Steal the marked car from the Rust Lotus yard (press E to get in)", "target": { "plaza": "Rust Lotus yard" }, "point": "YARD" },
    { "id": "garage.deliver", "text": "Drive the car to the Ghost Lot Garage", "target": { "poi": "garage" }, "point": "GARAGE" }
  ],
  "endText": "Act one continues soon. Free roam until then.",
  "moveHint": { "kb": "WASD to move, mouse to aim.", "pad": "Left stick to move.", "touch": "Left thumb moves." },
  "garage": {
    "car": { "type": "sports", "x": 103, "y": 75, "angle": 90, "hpMult": 1.6 },
    "deliverRadiusPx": 96,
    "ambush": { "base": 2, "levelStep": 5, "min": 2, "max": 4, "maxAlive": 4, "ring": 70, "cleanupSec": 6 }
  }
}